<div class="suggested-time-field" [ngClass]="{ 'selected-checkbox': dateTime.start === selectedTimeStart }">
    <div class="ui radio checkbox" (click)="onSelect(dateTime)">
        <input
            type="radio"
            name="dateTime"
            tabindex="0"
            class="hidden"
            [checked]="dateTime.start === selectedTimeStart"
        />
        <label
            ><span class="date">{{ dateTime.start | date: 'E, MMM d, y' }}</span
            ><span class="time"
                >{{ dateTime.start | date: 'h:mm a' }} - {{ dateTime.end | date: 'h:mm a' }}</span
            ></label
        >
    </div>
</div>
